/**
 * This is the fallback font stack that will be used if the browser
 * does not support our custom font(s), or it never loads.
 *
 * It is a list of fonts that are commonly supported
 * by browsers across platforms.
 */
export const FALLBACK_FONT_STACK =
  '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"';
